import React from "react";
import { Typography, Box } from "@mui/material";
import ReadMoreBox from "../../common/ReadMoreBox/ReadMoreBox";
import FallbackImage from "../FallbackImage/FallbackImage";
import PropTypes from "prop-types";
import styles from "./Article.module.css";

const Article = ({ className = "", image, heading, text, link }) => {
  return (
    <Box className={[styles.article, className].join(" ")}>
      <FallbackImage
        className={styles.articleImage}
        loading="lazy"
        alt=""
        src={image}
      />
      <Typography className={styles.articleHeading} variant="inherit" component="b">
        {heading}
      </Typography>
      <Box className={styles.articleText}>{text}</Box>
      <ReadMoreBox label="Read more" link={link} />
    </Box>
  );
};

Article.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default Article;